import { createContext, useContext, useEffect, useMemo, useState } from "react";

export const THEMES = [
  { id: "charcoal", name: "Charcoal · Yellow", dot: "#f2c200", bg: "#0d0d0d" },
  { id: "navy", name: "Deep Navy · Amber", dot: "#ffc21a", bg: "#0a1024" },
  { id: "gold", name: "Black · Luxe Gold", dot: "#c9a227", bg: "#080808" },
  { id: "ember", name: "Ember · Coral", dot: "#f6551f", bg: "#140b08" },
];

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("d4u-theme") || "charcoal";
    }
    return "charcoal";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("d4u-theme", theme);
  }, [theme]);

  const value = useMemo(() => ({ theme, setTheme }), [theme]);

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
